/**
 * Validated trust boundary for block `validate()` implementations.
 *
 * A block validator receives opaque authoring JSON (`unknown`) and checks every
 * field before it builds its typed `def`. Coercing that input to a partial
 * shape is therefore safe, but TypeScript cannot prove it — so the single
 * `no-unsafe-type-assertion` exception for this pattern lives here, in one
 * audited place, instead of being scattered across every block.
 *
 * Returns `null` for non-object input so callers can early-return with their
 * own "not an object" error.
 */
export function asPartialDef<T>(input: unknown): Partial<T> | null {
  if (typeof input !== "object" || input === null) {
    return null;
  }
  // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion -- validated trust boundary; every field is checked by the caller before use
  return input as Partial<T>;
}
